import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import { Grid, IconButton, Paper, Stack } from '@mui/material'
import { FormInputSelect, ItemOption } from 'components/FormInputSelect'
import React from 'react'
import { Control, UseFieldArrayRemove, UseFormWatch } from 'react-hook-form'
import { HearingNarrativesType } from 'types/hearing-narratives.type'
import FormInput from 'components/FormInput'
import FormInputNumber from 'components/FormInputNumber'

type InfractionGroupProps = {
  index: number
  control: Control<HearingNarrativesType>
  watch: UseFormWatch<HearingNarrativesType>
  typeOptions: ItemOption[]
  onRemove: UseFieldArrayRemove
}

export const InfractionGroup: React.FC<InfractionGroupProps> = ({
  index,
  control,
  watch,
  typeOptions,
  onRemove,
}) => {
  const infractionTypeId = String(watch(`atoInfracionais.${index}.tipo.id`))
  const isOthers = infractionTypeId === '3'

  return (
    <Paper variant='outlined' sx={{ ml: 2, mb: 2, p: 3, width: '100%' }}>
      <Grid container spacing={2}>
        <Grid item md={2} sm={6} xs={12}>
          <FormInput
            control={control}
            name={`atoInfracionais.${index}.artigo`}
            label='Artigo'
            placeholder='Informe o Artigo'
            maxLength={15}
          />
        </Grid>
        <Grid item md={2} sm={6} xs={12}>
          <FormInput
            control={control}
            name={`atoInfracionais.${index}.paragrafo`}
            label='Parágrafo'
            placeholder='Informe o Parágrafo'
            maxLength={15}
          />
        </Grid>
        <Grid item md={2} sm={6} xs={12}>
          <FormInput
            control={control}
            name={`atoInfracionais.${index}.inciso`}
            label='Inciso'
            placeholder='Informe o Inciso'
            maxLength={4}
          />
        </Grid>
        <Grid item md={2} sm={6} xs={12}>
          <FormInput
            control={control}
            name={`atoInfracionais.${index}.alinea`}
            label='Alínea'
            placeholder='informe a Alínea'
            maxLength={4}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <Stack spacing={1} direction='row'>
            <FormInputSelect
              control={control}
              name={`atoInfracionais.${index}.tipo.id`}
              label='Tipo'
              options={typeOptions}
            />
            {index >= 1 && (
              <IconButton onClick={() => onRemove(index)}>
                <DeleteOutlineRoundedIcon color='error' />
              </IconButton>
            )}
          </Stack>
        </Grid>

        {isOthers && (
          <>
            <Grid item md={6} xs={12}>
              <FormInputNumber
                control={control}
                name={`atoInfracionais.${index}.lei`}
                label='Lei Nº*'
                placeholder='Informe o Número da Lei'
                maxLength={5}
                //required={String(infractionTypeId) === '3'}
              />
            </Grid>
            <Grid item md={6} xs={12} sx={{ mb: 2 }}>
              <FormInputNumber
                control={control}
                name={`atoInfracionais.${index}.ano`}
                label='Ano*'
                maxLength={4}
                //required={String(infractionTypeId) === '3'}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Paper>
  )
}
